<div class="controls-header">
  <app-terug-knop-new [viewmodel]="viewmodel?.terugKnopViewmodel"></app-terug-knop-new>
  <app-klassendashboard-lesgroep-switch [viewmodel]="viewmodel?.lesgroepSwitchViewmodel" [navigeerbaar]="store.isNavigeerbaar() | async"></app-klassendashboard-lesgroep-switch>
  <app-datepicker class="right" [viewModel]="viewmodel?.datepickerViewmodel"></app-datepicker>
</div>
